import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';

interface ICheckoutTotalsElement {
    label: string;
    value: number;
}

@Component({
    selector: 'checkout-success-totals-section',
    templateUrl: './checkout-success-totals-section.html',
    standalone: true,
    imports: [NgClass, TranslationModule, PriceComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutSuccessTotalsSectionComponent implements OnInit {
    @Input()
    totals: Checkout.ITotals;

    totalsForDisplay: ICheckoutTotalsElement[] = [];

    ngOnInit() {
        this.totalsForDisplay = [
            { label: 'Subtotal', value: this.totals.subtotal },
            { label: 'Delivery', value: this.totals.delivery },
            { label: 'Discount', value: this.totals.discount },
            { label: 'Total price', value: this.totals.grand_total }
        ];
    }
}
